import { render } from "./UnauthenticatedUserFollowProjectModal.vue?vue&type=template&id=0152324e"
import script from "./UnauthenticatedUserFollowProjectModal.vue?vue&type=script&lang=js"
export * from "./UnauthenticatedUserFollowProjectModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__